/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import {
  BUTTON_FORMAT_SOFT,
  BUTTON_THEME_DEFAULT,
  ButtonProps,
  DIALOG_SIZE_SM_MD,
  DIALOG_TYPE_STANDARD,
  DialogContentProps,
  DialogProps,
  ICON_ADD_CIRCLE,
  useDialogStore,
} from '@squiz/sds';
import { DialogLauncher } from 'apps/console-core/src/Components/DialogLauncher/DialogLauncher';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { CONFIGURATION_STRINGS } from '../../../../Constants/Strings.constants';
import { DAM_INTEGRATIONS_DATA_IDS } from '../../DamIntegrations.constants';
import { AddDamIntegration } from '../../forms/AddDamIntegration/AddDamIntegration';
import { AddDamButtonProps } from './AddDamButton.props';

/**
 * The button to add a new DAM integration.
 */
export const AddDamButton = (props: AddDamButtonProps): JSX.Element => {
  const { t } = useTranslation();
  const { disabled, format, icon, theme } = props;

  // Labels
  const labels = useMemo(() => {
    return {
      addDam: t(CONFIGURATION_STRINGS.addDam),
    };
  }, [t]);

  const buttonProps: ButtonProps = {
    dataId: DAM_INTEGRATIONS_DATA_IDS.actionAddIntegration,
    disabled,
    format: format ?? BUTTON_FORMAT_SOFT,
    icon,
    text: labels.addDam,
    theme: theme ?? BUTTON_THEME_DEFAULT,
  };

  const dialogProps: DialogProps = {
    dialogContent: {
      renderContent: (dialogProps: DialogContentProps): JSX.Element => {
        const formProps = { ...dialogProps };
        formProps.customProps = props;
        return <AddDamIntegration {...formProps} />;
      },
    },
    dialogSize: DIALOG_SIZE_SM_MD,
    dialogType: DIALOG_TYPE_STANDARD,
    heading: labels.addDam,
    icon: ICON_ADD_CIRCLE,
    scrollOnOverflow: false,
    stateHandler: useDialogStore,
  };

  return <DialogLauncher buttonProps={buttonProps} dialogProps={dialogProps} />;
};
